package modysy.menu

import modysy.InputHandler
import modysy.datastructures.Vector2
import modysy.view.Color
import org.scalajs.dom
import org.scalajs.dom.CanvasRenderingContext2D
import org.scalajs.dom.raw.TextMetrics

/**
  *
  * An AbstractButton which displays a text
  * The size of the button equals the size of the text
  *
  * Optional Attributes that can be changed after creation:
  *
  * font: font of the text
  * fontSize: font-size of the text
  * colorNormal: color the text will be displayed in
  * colorSelected: color the text will be displayed in if mouse is pointing on the button
  *
  * @param x             x-Position of button on canvas
  * @param y             y-Position of button on canvas
  * @param textDisplayed text the button shows
  *
  */
class TextButton(x: Double, y: Double, textDisplayed: String)
    extends AbstractButton(x, y) {

  private var textMetrics: Option[TextMetrics] = None
  var font: String = "Arial"
  var fontSize: Int = 16
  var colorNormal: String = Color.White
  var colorSelected: String = Color.Red
  var colorDisabled: String = Color.Grey

  private var left_border = 0.0
  private var right_border = 0.0
  private var upper_border = 0.0
  private var lower_border = 0.0

  /**
    * Displays the Button
    *
    * @param ctx The CanvasRenderingContext2D of the canvas
    */
  override def render(ctx: CanvasRenderingContext2D): Unit = {

    ctx.font = this.fontSize + "px " + this.font
    ctx.textAlign = "center"
    ctx.textBaseline = "alphabetic"
    ctx.fillStyle =
      if (_mousePointing || fingerPointing) colorSelected
      else if (isEnabled()) colorNormal
      else colorDisabled
    ctx.fillText(textDisplayed, x, y, Integer.MAX_VALUE)

    if (textMetrics.isEmpty) {
      textMetrics = Some(ctx.measureText(textDisplayed))
      left_border = x - textMetrics.get.width / 2
      right_border = x + textMetrics.get.width / 2
      upper_border = y - fontSize * 0.75
      lower_border = y
    }

  }

  override protected def pointOnButton(point: Vector2): Boolean = {
    point.x > left_border && point.x < right_border && point.y < lower_border && point.y > upper_border
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/menu/TextButton.scala